/* Cinemapp info widget
   ---------------------------------------------------------------
   Renders a Cinemapp film embed below a post. No code injection
   needed: just add a line to the post body (its own paragraph), e.g.

       EMBED=https://cinemapp.be/nl/film/cc317371/backrooms

   The marker line is removed and the embed is rendered below the
   post content. The cid (e.g. cc317371 — one or two leading "c"s)
   is parsed from the URL; a bare cid works too. Everything else in
   the embed stays fixed.

   A global cinemapp("<url>") is also exposed for use from Code
   Injection if you'd rather drive it that way. */
(function () {
    const WIDGET_SRC = 'https://d3aog8ssp5mt39.cloudfront.net/widget/info-widget.js';
    const INCLUDE = 'poster,releaseDate,runtime,genres,cast,country,theaters,streaming';
    const MARKER = /EMBED\s*=\s*(\S+)/i;

    function parseCid(input) {
        if (!input) return null;
        const value = String(input).trim();
        // Full Cinemapp URL: take the path segment right after /film/
        const match = value.match(/\/film\/([^/?#\s]+)/i);
        if (match) return match[1];
        // Bare cid pasted directly (one or two leading "c"s)
        if (/^c{1,2}[a-z0-9]+$/i.test(value)) return value;
        return null;
    }

    function loadWidgetScript() {
        if (document.querySelector('script[src="' + WIDGET_SRC + '"]')) return;
        const script = document.createElement('script');
        script.src = WIDGET_SRC;
        script.async = true;
        document.body.appendChild(script);
    }

    function renderCid(cid) {
        const article = document.querySelector('.gh-article');
        if (!cid || !article || article.querySelector('.ff-cinemapp')) return;

        const widget = document.createElement('cinemapp-info');
        widget.setAttribute('cid', cid);
        widget.setAttribute('country', 'be');
        widget.setAttribute('language', 'nl');
        widget.setAttribute('theme', 'light');
        widget.setAttribute('include', INCLUDE);

        const wrapper = document.createElement('div');
        wrapper.className = 'ff-cinemapp';
        wrapper.appendChild(widget);

        const content = article.querySelector('.gh-content');
        if (content) {
            content.insertAdjacentElement('afterend', wrapper);
        } else {
            article.appendChild(wrapper);
        }

        loadWidgetScript();
    }

    // Look for an `EMBED=<url>` line in the post body, strip it, and render.
    function scanContent() {
        const content = document.querySelector('.gh-article .gh-content');
        if (!content) return;

        const blocks = content.querySelectorAll('p, div');
        for (let i = 0; i < blocks.length; i++) {
            const el = blocks[i];
            const text = (el.textContent || '').trim();
            if (!/^EMBED\s*=/i.test(text)) continue;

            const match = text.match(MARKER);
            const cid = match && parseCid(match[1]);
            el.remove();
            if (cid) renderCid(cid);
            return;
        }
    }

    function onReady(fn) {
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', fn);
        } else {
            fn();
        }
    }

    // Optional manual trigger from Code Injection.
    window.cinemapp = function (url) {
        onReady(function () {
            renderCid(parseCid(url));
        });
    };

    onReady(scanContent);
})();
